import { ErrorLike } from "@apollo/client"
import { useQuery } from "@apollo/client/react"
import { getUserDataSourceQuery } from "../../../queries/__generated-typings__/getUserDataSource"
import { getUserDataSource } from "../../../queries/getUserDataSource"
import { useUserBehaviours } from "../../../hooks/useUserBehaviours"
import { useTokenData } from "../../../hooks/useTokenData"

type FirstAccessPosteResponse = {
  data: {
    id: string | null
    askToReadDocs: boolean
  }
  error: ErrorLike | undefined
  loading: boolean
}

export const useUserFirstAccessPoste = (): FirstAccessPosteResponse => {
  const {
    data: userData,
    error: errorUserData,
    loading: loadingUserData
  } = useQuery<getUserDataSourceQuery>(getUserDataSource)
  const { data: tokenData } = useTokenData()

  const userId = userData?.credimi_futuro_dossiers_view[0]?.company?.profiles[0]?.contact?.sfid

  const { userBehaviours, error, loading } = useUserBehaviours(
    userId,
    "partner_api_transparency_documentation_and_terms_conditions"
  )

  if (userData?.credimi_futuro_dossiers_view && userBehaviours) {
    const hasReadDocs = userBehaviours.user_behaviours?.find(el => el?.value === "true")
    const isApplicationPartnerPoste = !!tokenData?.isPartnerPoste

    const askToReadDocs = isApplicationPartnerPoste && !hasReadDocs

    return {
      data: {
        id: userData?.credimi_futuro_dossiers_view[0]?.company?.profiles[0]?.contact?.sfid || null,
        askToReadDocs
      },
      error: error || errorUserData,
      loading: loading || loadingUserData
    }
  }

  return {
    data: { id: null, askToReadDocs: false },
    error: error || errorUserData,
    loading: loading || loadingUserData
  }
}
